import { render, staticRenderFns } from "./FieldDate.vue?vue&type=template&id=65f9dff2&scoped=true"
import script from "./FieldDate.vue?vue&type=script&lang=js"
export * from "./FieldDate.vue?vue&type=script&lang=js"
import style0 from "./FieldDate.vue?vue&type=style&index=0&id=65f9dff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f9dff2",
  null
  
)

export default component.exports